import { getFloorOffsetFromApartment } from "@project-rouge/rg-core";
function getFflFromFloors(dataset, floors) {
	const { f2fHeight } = dataset.aggConfig;
	const floorOffset = getFloorOffsetFromApartment(dataset.apartments.all[0]);
	return (floors - 1) * f2fHeight + floorOffset;
}
export { getFflFromFloors };

//# sourceMappingURL=index16.js.map